export default __webpack_public_path__ + "static/media/Calendar.977b5557.svg";